export default __webpack_public_path__ + "static/media/bannerImage22.e07c30d2.png";